import { memo } from "react";
import styled, { css, keyframes } from "styled-components";
import icons from '../../assets/sprite.svg';

const StyledCell = styled.div`
    width: 33px;
    height: 33px;
    line-height: 33px;

    ${props => (props.isPlayerField && props.isTarget) || props.isKilled ? css`
        backdrop-filter: invert(35%);
        border-radius: 2px;
        -webkit-backdrop-filter: invert(35%);
        ` : css`background: transparent;`
    }
`;

const explosion = keyframes`
    0% {
        opacity: 0;
        transform: scale(.2);
    }
    50% {
        opacity: 1;
        transform: scale(1);
    }
    100% { 
        opacity: 0;
    }
`;

const Icon = styled.svg`
    width: ${props => props.visual === 'shot' ? '30px' : '15px'};
    height: ${props => props.visual === 'shot' ? '30px' : '15px'};
    margin: 0 auto;
    fill: ${props => {
        switch(props.visual) {
            case 'hit': return '#8B0000';
            case 'miss': return 'darkslategray';
            case 'mark': return 'darkslategray';
            case 'shot': return 'darkorange';
            case 'shotOnMarked': return '#8B0000';
            default: return 'none';
        }
    }};

    animation-name: ${props => props.visual === 'shot' ? explosion : 'none'};
    animation-duration: 0.4s;
`;

// ${props => props.visual === 'shot' ? css`
//     nimation-name: ${explosion}
//     animation-duration: 0.4s;` : ''}



const Cell = ({ id, visual, target, killed, fieldOwner }) => {
    const iconName = visual === 'shotOnMarked' ? 'mark' : visual;
    return (
        <StyledCell isTarget={target} isPlayerField={fieldOwner === 'player'} isKilled={killed} data-id={id} key={id}>
            <Icon visual={visual}>
                <use href={icons + '#' + iconName}/>
            </Icon>
        </StyledCell>
    );
}

export default memo(Cell);